import { render } from "./OptionsView.vue?vue&type=template&id=175a79ff&scoped=true"
import script from "./OptionsView.vue?vue&type=script&lang=js"
export * from "./OptionsView.vue?vue&type=script&lang=js"

import "./OptionsView.vue?vue&type=style&index=0&id=175a79ff&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175a79ff"]])

export default __exports__